import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=5fca062b&scoped=true&"
import script from "./Doughnut.vue?vue&type=script&lang=js&"
export * from "./Doughnut.vue?vue&type=script&lang=js&"
import style0 from "./Doughnut.vue?vue&type=style&index=0&id=5fca062b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca062b",
  null
  
)

export default component.exports